// QICM-20 — Questionnaire d'Insight Cognitif et de Métacognition (bilingue FR / ES).
// Inspiré du Beck Cognitive Insight Scale (BCIS). 20 items, échelle 0–4.

export const QICM_SCALE = {
  fr: [
    { value: 0, label: "Pas du tout d'accord" },
    { value: 1, label: "Plutôt pas d'accord" },
    { value: 2, label: "Ni d'accord, ni pas d'accord" },
    { value: 3, label: "Plutôt d'accord" },
    { value: 4, label: "Tout à fait d'accord" },
  ],
  es: [
    { value: 0, label: "Totalmente en desacuerdo" },
    { value: 1, label: "Más bien en desacuerdo" },
    { value: 2, label: "Ni de acuerdo ni en desacuerdo" },
    { value: 3, label: "Más bien de acuerdo" },
    { value: 4, label: "Totalmente de acuerdo" },
  ],
};

export const QICM_DIMENSIONS = [
  { key: "reflexivite", feminine: true, color: "#8A6D56", items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    name: { fr: "Auto-réflexivité", es: "Autorreflexividad" },
    description: { fr: "Capacité à prendre du recul sur ses pensées.", es: "Capacidad para tomar distancia de los propios pensamientos." } },
  { key: "certitude", feminine: true, color: "#B0553B", items: [11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
    name: { fr: "Certitude cognitive", es: "Certeza cognitiva" },
    description: { fr: "Tendance à considérer ses interprétations comme vraies.", es: "Tendencia a considerar verdaderas las propias interpretaciones." } },
];

const QF = [
  "Je reconnais qu'il m'arrive d'interpréter une situation de manière inexacte.",
  "Lorsque je ressens une émotion intense, je vérifie si elle influence mon jugement.",
  "Avant de conclure, j'envisage plusieurs explications possibles.",
  "J'aime comprendre pourquoi je pense ou je réagis d'une certaine manière.",
  "Lorsque quelqu'un n'est pas d'accord avec moi, je cherche sincèrement à comprendre son raisonnement.",
  "Je peux modifier mon opinion lorsqu'on m'apporte des informations convaincantes.",
  "Je remets facilement en question ma première impression.",
  "Je me demande régulièrement si mes expériences passées influencent ma manière d'interpréter les événements.",
  "Je remarque rapidement lorsque je tire des conclusions trop hâtives.",
  "Je peux accepter de rester dans l'incertitude avant de prendre une décision.",
  "Lorsque je suis convaincu d'avoir raison, il est difficile de me faire changer d'avis.",
  "Je fais généralement confiance à ma première impression sans ressentir le besoin de la vérifier.",
  "Lorsque je ressens quelque chose très fortement, cela signifie souvent pour moi que c'est vrai.",
  "Je pense comprendre rapidement les intentions des autres.",
  "Quand quelqu'un me contredit, je pense souvent qu'il ne comprend pas réellement la situation.",
  "Je sais rapidement ce que les autres pensent de moi.",
  "Mon intuition suffit souvent pour me convaincre que j'ai raison.",
  "Mes premières impressions sont rarement erronées.",
  "Une fois que j'ai formé une opinion, je la remets rarement en question.",
  "Je ressens rarement le besoin de demander l'avis d'autres personnes avant de tirer une conclusion.",
];

const QE = [
  "Reconozco que a veces interpreto una situación de manera inexacta.",
  "Cuando siento una emoción intensa, compruebo si influye en mi juicio.",
  "Antes de concluir, considero varias explicaciones posibles.",
  "Me gusta comprender por qué pienso o reacciono de cierta manera.",
  "Cuando alguien no está de acuerdo conmigo, intento sinceramente comprender su razonamiento.",
  "Puedo cambiar de opinión cuando me aportan información convincente.",
  "Cuestiono fácilmente mi primera impresión.",
  "Me pregunto con regularidad si mis experiencias pasadas influyen en cómo interpreto los acontecimientos.",
  "Me doy cuenta rápidamente cuando saco conclusiones demasiado precipitadas.",
  "Puedo aceptar permanecer en la incertidumbre antes de tomar una decisión.",
  "Cuando estoy convencido de tener razón, es difícil hacerme cambiar de opinión.",
  "Por lo general confío en mi primera impresión sin sentir la necesidad de comprobarla.",
  "Cuando siento algo con mucha fuerza, para mí suele significar que es verdad.",
  "Creo que comprendo rápidamente las intenciones de los demás.",
  "Cuando alguien me contradice, a menudo pienso que no comprende realmente la situación.",
  "Sé rápidamente lo que los demás piensan de mí.",
  "Mi intuición basta a menudo para convencerme de que tengo razón.",
  "Mis primeras impresiones rara vez son erróneas.",
  "Una vez que me he formado una opinión, rara vez la cuestiono.",
  "Rara vez siento la necesidad de pedir la opinión de otras personas antes de sacar una conclusión.",
];

export const QICM_ITEMS = QF.map((text, i) => ({ n: i + 1, dim: i < 10 ? "reflexivite" : "certitude", fr: text, es: QE[i] }));

export const DIM_LEVELS = [
  { min: 0, max: 10, color: "#8A9A6D", fr: { m: "Très faible", f: "Très faible" }, es: { m: "Muy bajo", f: "Muy baja" } },
  { min: 11, max: 20, color: "#D4A77B", fr: { m: "Faible", f: "Faible" }, es: { m: "Bajo", f: "Baja" } },
  { min: 21, max: 30, color: "#E99F4F", fr: { m: "Modéré", f: "Modérée" }, es: { m: "Moderado", f: "Moderada" } },
  { min: 31, max: 36, color: "#C08552", fr: { m: "Élevé", f: "Élevée" }, es: { m: "Elevado", f: "Elevada" } },
  { min: 37, max: 40, color: "#B0553B", fr: { m: "Très élevé", f: "Très élevée" }, es: { m: "Muy elevado", f: "Muy elevada" } },
];

export const IIC_LEVELS = [
  { min: 25, max: 40, color: "#8A6D56", fr: "Excellent", es: "Excelente" },
  { min: 10, max: 24, color: "#B58C67", fr: "Bon", es: "Bueno" },
  { min: -9, max: 9, color: "#D4A77B", fr: "Moyen", es: "Medio" },
  { min: -24, max: -10, color: "#E99F4F", fr: "Faible", es: "Bajo" },
  { min: -40, max: -25, color: "#B0553B", fr: "Très faible", es: "Muy bajo" },
];

export const IFC_LEVELS = [
  { min: 0, max: 34.999, color: "#B0553B", fr: "Fonctionnement très rigide", es: "Funcionamiento muy rígido" },
  { min: 35, max: 49.999, color: "#C08552", fr: "Flexibilité limitée", es: "Flexibilidad limitada" },
  { min: 50, max: 64.999, color: "#E99F4F", fr: "Flexibilité moyenne", es: "Flexibilidad media" },
  { min: 65, max: 79.999, color: "#B58C67", fr: "Bonne flexibilité", es: "Buena flexibilidad" },
  { min: 80, max: 100, color: "#8A6D56", fr: "Excellente flexibilité cognitive", es: "Excelente flexibilidad cognitiva" },
];

export const QICM_PROFILES = {
  A: { code: "A", color: "#8A6D56",
    name: { fr: "Flexible", es: "Flexible" },
    axis: { fr: "Réflexivité ↑ — Certitude ↓", es: "Reflexividad ↑ — Certeza ↓" },
    caracteristiques: { fr: "Bonne capacité de recul ; accepte facilement plusieurs hypothèses ; distingue les faits des interprétations ; bonne tolérance à l'incertitude.", es: "Buena capacidad de distancia; acepta fácilmente varias hipótesis; distingue los hechos de las interpretaciones; buena tolerancia a la incertidumbre." },
    noteLabel: { fr: "Forces", es: "Fortalezas" },
    note: { fr: "Apprentissage ; adaptation ; résolution de problèmes.", es: "Aprendizaje; adaptación; resolución de problemas." } },
  B: { code: "B", color: "#C08552",
    name: { fr: "Ruminatif", es: "Rumiativo" },
    axis: { fr: "Réflexivité ↑ — Certitude ↑", es: "Reflexividad ↑ — Certeza ↑" },
    caracteristiques: { fr: "Réfléchit beaucoup ; analyse en permanence ; doute malgré de fortes convictions.", es: "Reflexiona mucho; analiza constantemente; duda a pesar de fuertes convicciones." },
    noteLabel: { fr: "À explorer", es: "A explorar" },
    note: { fr: "Anxiété ; perfectionnisme ; besoin de contrôle ; TOC ; rumination.", es: "Ansiedad; perfeccionismo; necesidad de control; TOC; rumiación." } },
  C: { code: "C", color: "#B0553B",
    name: { fr: "Rigide", es: "Rígido" },
    axis: { fr: "Réflexivité ↓ — Certitude ↑", es: "Reflexividad ↓ — Certeza ↑" },
    caracteristiques: { fr: "Confiance importante dans ses interprétations ; difficulté à intégrer un point de vue différent ; tendance au biais de confirmation.", es: "Gran confianza en sus interpretaciones; dificultad para integrar un punto de vista diferente; tendencia al sesgo de confirmación." },
    noteLabel: { fr: "Biais fréquemment observés", es: "Sesgos frecuentes" },
    note: { fr: "Lecture de pensée ; personnalisation ; conclusions hâtives ; raisonnement émotionnel ; pensée dichotomique.", es: "Lectura de pensamiento; personalización; conclusiones precipitadas; razonamiento emocional; pensamiento dicotómico." } },
  D: { code: "D", color: "#8A9A6D",
    name: { fr: "Indécis / évitant", es: "Indeciso / evitativo" },
    axis: { fr: "Réflexivité ↓ — Certitude ↓", es: "Reflexividad ↓ — Certeza ↓" },
    caracteristiques: { fr: "Peu d'analyse ; hésitation importante ; faible confiance dans son jugement.", es: "Poco análisis; vacilación importante; escasa confianza en el propio juicio." },
    noteLabel: { fr: "À différencier de", es: "A diferenciar de" },
    note: { fr: "Une fatigue cognitive, un épisode dépressif ou une faible estime de soi.", es: "Fatiga cognitiva, episodio depresivo o baja autoestima." } },
};

export const QICM_ITEM_FLAGS = {
  2: { fr: "influence des émotions sur le raisonnement", es: "influencia de las emociones en el razonamiento" },
  3: { fr: "génération d'hypothèses alternatives", es: "generación de hipótesis alternativas" },
  5: { fr: "ouverture aux autres perspectives", es: "apertura a otras perspectivas" },
  7: { fr: "remise en question des premières impressions", es: "cuestionamiento de las primeras impresiones" },
  10: { fr: "tolérance à l'incertitude", es: "tolerancia a la incertidumbre" },
  13: { fr: "raisonnement émotionnel (« si je le ressens, c'est vrai »)", es: "razonamiento emocional («si lo siento, es verdad»)" },
  16: { fr: "lecture de pensée", es: "lectura de pensamiento" },
  17: { fr: "confiance dans l'intuition", es: "confianza en la intuición" },
  18: { fr: "excès de confiance", es: "exceso de confianza" },
  19: { fr: "rigidité des croyances", es: "rigidez de las creencias" },
};

export const QICM_T = {
  fr: {
    allModules: "← Tous les modules",
    welcomeTitle: "Insight Cognitif et Métacognition",
    welcomeText: "Ce questionnaire explore votre façon de prendre du recul sur vos pensées et la confiance que vous accordez à vos interprétations. Il comporte 20 affirmations. Répondez spontanément.",
    start: "Commencer",
    consigne: "Consigne",
    consigneP1: "Il n'existe ni bonne ni mauvaise réponse. Répondez spontanément en indiquant dans quelle mesure chaque affirmation vous correspond habituellement.",
    consigneP2: "Répondez en pensant à votre fonctionnement général plutôt qu'à une situation exceptionnelle.",
    resultsLater: "Vos scores et leur interprétation vous seront présentés uniquement à la fin.",
    prev: "Précédent",
    begin: "Commencer la passation",
    step: "Étape",
    of: "sur",
    seeResults: "Voir mes résultats",
    next: "Suivant",
    completeStep: "Merci de répondre à toutes les affirmations de cette étape pour continuer.",
    thanks: "Merci d'avoir complété le questionnaire",
    thanksText: "Les résultats qui suivent constituent un support de réflexion clinique. Ils ne représentent pas un diagnostic mais une photographie de votre fonctionnement cognitif au moment de cette évaluation.",
    dimsTitle: "Vos deux dimensions",
    dimsSub: "Scores par dimension (0 – 40)",
    mapTitle: "Cartographie du profil",
    mapSub: "Réflexivité × Certitude — situez votre profil parmi les 4 quadrants",
    axisRefl: "Auto-réflexivité →",
    axisCert: "Certitude →",
    yourPosition: "Votre position",
    quadA: "A · Flexible", quadB: "B · Ruminatif", quadC: "C · Rigide", quadD: "D · Indécis",
    iicTitle: "Indice d'Insight Cognitif",
    iicSub: "Auto-réflexivité − Certitude cognitive (−40 à +40)",
    ifcTitle: "Indice de Flexibilité Cognitive",
    ifcSub: "Réflexivité / (Réflexivité + Certitude) × 100",
    ifcNA: "Non calculable (aucun point sur les deux dimensions).",
    profilePrefix: "Profil",
    interpTitle: "Interprétation des scores",
    interpSub: "Grille de lecture par dimension (/40)",
    flaggedTitle: "Points d'attention",
    flaggedSub: "Items à score élevé pouvant orienter l'entretien",
    clinicalTitle: "Lecture clinique",
    recoTitle: "Pistes thérapeutiques",
    exportPdf: "Exporter en PDF",
    restart: "Recommencer",
  },
  es: {
    allModules: "← Todos los módulos",
    welcomeTitle: "Insight Cognitivo y Metacognición",
    welcomeText: "Este cuestionario explora tu forma de tomar distancia de tus pensamientos y la confianza que otorgas a tus interpretaciones. Consta de 20 afirmaciones. Responde con espontaneidad.",
    start: "Empezar",
    consigne: "Instrucciones",
    consigneP1: "No hay respuestas correctas ni incorrectas. Responde con espontaneidad indicando en qué medida cada afirmación te corresponde habitualmente.",
    consigneP2: "Responde pensando en tu funcionamiento general más que en una situación excepcional.",
    resultsLater: "Tus puntuaciones y su interpretación se mostrarán únicamente al final.",
    prev: "Anterior",
    begin: "Comenzar el cuestionario",
    step: "Etapa",
    of: "de",
    seeResults: "Ver mis resultados",
    next: "Siguiente",
    completeStep: "Responde a todas las afirmaciones de esta etapa para continuar.",
    thanks: "Gracias por completar el cuestionario",
    thanksText: "Los resultados siguientes constituyen un apoyo de reflexión clínica. No representan un diagnóstico, sino una fotografía de tu funcionamiento cognitivo en el momento de esta evaluación.",
    dimsTitle: "Tus dos dimensiones",
    dimsSub: "Puntuaciones por dimensión (0 – 40)",
    mapTitle: "Mapa del perfil",
    mapSub: "Reflexividad × Certeza — sitúa tu perfil entre los 4 cuadrantes",
    axisRefl: "Autorreflexividad →",
    axisCert: "Certeza →",
    yourPosition: "Tu posición",
    quadA: "A · Flexible", quadB: "B · Rumiativo", quadC: "C · Rígido", quadD: "D · Indeciso",
    iicTitle: "Índice de Insight Cognitivo",
    iicSub: "Autorreflexividad − Certeza cognitiva (−40 a +40)",
    ifcTitle: "Índice de Flexibilidad Cognitiva",
    ifcSub: "Reflexividad / (Reflexividad + Certeza) × 100",
    ifcNA: "No calculable (ningún punto en las dos dimensiones).",
    profilePrefix: "Perfil",
    interpTitle: "Interpretación de las puntuaciones",
    interpSub: "Guía de lectura por dimensión (/40)",
    flaggedTitle: "Puntos de atención",
    flaggedSub: "Ítems con puntuación alta que pueden orientar la entrevista",
    clinicalTitle: "Lectura clínica",
    recoTitle: "Pistas terapéuticas",
    exportPdf: "Exportar en PDF",
    restart: "Reiniciar",
  },
};
